/* NinjaGamer Theme JS */

// Cart count update
document.addEventListener('DOMContentLoaded', function () {

  // Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 12px rgba(0,0,0,.1)' : '0 1px 4px rgba(0,0,0,.06)';
    });
  }

  // Add to cart via AJAX
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const original = this.textContent;
      this.textContent = 'Adicionando...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(err => {
        this.textContent = (err && err.description) || 'Indisponível';
        setTimeout(() => {
          this.textContent = original;
          this.disabled = false;
        }, 3000);
      });
    });
  });

  function updateCartCount(count) {
    if (count === undefined) {
      fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count));
      return;
    }
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  updateCartCount();

  // Product page "Adicionar ao Carrinho" form → redirect to cart page
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const variantId = document.getElementById('variant-id')?.value;
      if (!variantId) return;

      btn.textContent = 'Adicionando...';
      btn.disabled = true;

      const comparePrice = document.getElementById('variant-compare')?.value || 0;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { _compare: comparePrice } })
      })
      .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(err => {
        btn.textContent = (err && err.description) || 'Indisponível';
        setTimeout(() => {
          btn.textContent = btn.dataset.availableText || 'Adicionar ao Carrinho';
          btn.disabled = false;
        }, 3000);
      });
    });
  }

  // ── WISHLIST ─────────────────────────────────────────────
  const WL_KEY = 'ninja_wishlist';
  function wlGet() {
    try {
      const data = JSON.parse(localStorage.getItem(WL_KEY)) || [];
      return data.map(item => typeof item === 'string' ? { id: item } : item);
    } catch(e) { return []; }
  }
  function wlSet(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch(e) {} }
  function wlHas(id) { return wlGet().some(p => p.id === String(id)); }
  function wlToggle(btn) {
    const id = String(btn.dataset.productId);
    const list = wlGet();
    const idx = list.findIndex(p => p.id === id);
    if (idx === -1) {
      list.push({
        id,
        url:     btn.dataset.productUrl     || '',
        title:   btn.dataset.productTitle   || '',
        image:   btn.dataset.productImage   || '',
        price:   parseInt(btn.dataset.productPrice)   || 0,
        compare: parseInt(btn.dataset.productCompare) || 0
      });
    } else {
      list.splice(idx, 1);
    }
    wlSet(list);
    return list.some(p => p.id === id);
  }
  function wlUpdateCount() {
    const count = wlGet().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count > 9 ? '9+' : count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    if (wlHas(btn.dataset.productId)) btn.classList.add('product-card__wishlist--active');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isActive = wlToggle(btn);
      btn.classList.toggle('product-card__wishlist--active', isActive);
      wlUpdateCount();
    });
  });
  wlUpdateCount();

  // ── WISHLIST DRAWER ──────────────────────────────────────
  function openWishlistDrawer() {
    const wd = document.getElementById('wishlist-drawer');
    if (!wd) return;
    document.body.classList.add('cart-drawer-active');
    wd.classList.add('cart-drawer--open');
    wd.setAttribute('aria-hidden', 'false');
    renderWishlistDrawer();
  }
  function closeWishlistDrawer() {
    const wd = document.getElementById('wishlist-drawer');
    if (!wd) return;
    document.body.classList.remove('cart-drawer-active');
    wd.classList.remove('cart-drawer--open');
    wd.setAttribute('aria-hidden', 'true');
  }
  function renderWishlistDrawer() {
    const body = document.getElementById('wishlist-drawer-body');
    if (!body) return;
    const list = wlGet().filter(p => p.url);
    if (list.length === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<p>Nenhum favorito ainda</p>' +
          '<button type="button" class="btn btn--primary" id="wl-explore">Explorar jogos</button>' +
        '</div>';
      document.getElementById('wl-explore')?.addEventListener('click', () => { closeWishlistDrawer(); window.location = '/collections/all'; });
      return;
    }
    body.innerHTML = list.map(p => {
      const price = 'R$ ' + (p.price / 100).toFixed(2).replace('.', ',');
      const img   = p.image ? `<img class="cart-drawer__item-img" src="${p.image}" alt="${p.title}">` : '<div class="cart-drawer__item-img"></div>';
      return `<div class="cart-drawer__item">
        <a href="${p.url}">${img}</a>
        <div class="cart-drawer__item-info">
          <a href="${p.url}" class="cart-drawer__item-title">${p.title}</a>
          <span class="cart-drawer__item-price">${price}</span>
          <button class="cart-drawer__item-remove" data-wl-id="${p.id}">Remover dos favoritos</button>
        </div>
      </div>`;
    }).join('');
    body.querySelectorAll('.cart-drawer__item-remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const id   = this.dataset.wlId;
        const newList = wlGet().filter(p => p.id !== id);
        wlSet(newList);
        wlUpdateCount();
        document.querySelectorAll(`.product-card__wishlist[data-product-id="${id}"]`).forEach(b => b.classList.remove('product-card__wishlist--active'));
        renderWishlistDrawer();
      });
    });
  }
  document.getElementById('open-wishlist-drawer')?.addEventListener('click', openWishlistDrawer);
  document.getElementById('wishlist-drawer-overlay')?.addEventListener('click', closeWishlistDrawer);
  document.getElementById('wishlist-drawer-close')?.addEventListener('click', closeWishlistDrawer);
  // ─────────────────────────────────────────────────────────

  // Product accordion
  document.querySelectorAll('.product-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      const body = this.nextElementSibling;
      this.setAttribute('aria-expanded', !isOpen);
      body.classList.toggle('product-accordion__body--open', !isOpen);
    });
  });

  // Product page thumbnail gallery
  document.querySelectorAll('.product-page__thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.product-page__main-img');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
      }
      document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('product-page__thumb--active'));
      this.classList.add('product-page__thumb--active');
    });
  });

  // Yampi checkout interceptor para cart drawer
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#ymp-cart-form button[name="checkout"]');
    if(btn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          fetch('https://api.dooki.com.br/v2/public/shopify/cart', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              shop: '0e0qgn-mr.myshopify.com',
              cart_token: cart.token
            })
          })
          .then(function(r){ return r.json(); })
          .then(function(data){
            if(data && data.checkout_direct_url && data.checkout_direct_url !== '') {
              window.location.href = data.checkout_direct_url;
            } else {
              window.location.href = '/checkout';
            }
          });
        });
    }
  }, true);

});
